(function($, d, g) {

    'use strict';
    var lang = d.documentElement.lang;
    
    var currPage;
    var meTable;
    var deleteBtn;
    var cancelBtn;
    var deleteInvitationBtn;
    var refundAllTicketsBtn;
    var confirmForm;
    var eventRow;
    var attendeesBtn;
    
    var confirmAction = function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        if (confirmForm) {
            ajaxBlackout(true);
            confirmForm.submit();
        }
    };
    
    var deleteEvent = function(e) {
        confirmForm = $(this).closest("form")[0];
        $("#manage_events_prompt_delete .popup-inner-content-btn .btn")
                // .css("position", "absolute") // looks weird
                .click(confirmAction);
        openWindow("manage_events_prompt_delete", true);
    };
    
    var cancelEvent = function(e) {
        confirmForm = $(this).closest("form")[0];
        $("#manage_events_prompt_cancel .popup-inner-content-btn .btn")
                // .css("position", "absolute")
                .click(confirmAction);
        openWindow("manage_events_prompt_cancel", true);
    };
    
    var deleteInvitation = function(e) {
        confirmForm = $(this).closest("form")[0];
        $("#manage_events_prompt_delete_invitation .popup-inner-content-btn .btn")
                .click(confirmAction);
        openWindow("manage_events_prompt_delete_invitation", true);
    };
    
    var refundAll = function(e) {
        var t = $(this);
        openWindow("manage_events_prompt_confirm_refund_all_request", true);
        confirmForm = t.closest("form")[0];

        var checksP = $('#manage_events_prompt_confirm_refund_all_request').find('.check-sum-refund');
        var consigneP = $('#manage_events_prompt_confirm_refund_all_request').find('.consigne-sum-refund');
        var ticketAmountSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-amount');
        var ticketNumSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-num');
        var ticketAmountCheckSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-amount-check');
        var ticketNumCheckSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-num-check');
        var ticketAmountConsigneSpan = $('#manage_events_prompt_confirm_refund_all_request').find('.refund-all-tickets-num-consigne');

        var url = '/action/epRefund';
        url += '?eventId=' + $(confirmForm).find('input[name=eventId]').val();
        url += '&data=true';
        url += '&ajax=true';

        ajax(url, function(response){
            var resp = response.split('~');
            try{
                ticketAmountSpan.html(parseFloat(resp[0]).toFixed(2));
                ticketNumSpan.html(resp[1]);
                if (parseFloat(resp[2]) !== 0) {
                    checksP.removeClass("hide");
                    ticketAmountCheckSpan.html(parseFloat(resp[2]).toFixed(2));
                    ticketNumCheckSpan.html(resp[3]);
                } else {
                    checksP.addClass("hide");
                }
                if (parseFloat(resp[4]) !== 0) {
                    consigneP.removeClass("hide");
                    ticketAmountConsigneSpan.html(resp[4]);
                } else {
                    consigneP.addClass("hide");
                }
            } catch (e) {
                console.log(e);
            }
        },true); 
        $("#manage_events_prompt_confirm_refund_all_request .popup-inner-content-btn .btn").unbind();
        $("#manage_events_prompt_confirm_refund_all_request .popup-inner-content-btn .btn")
            .one('click', function() {
                $(this).closest('.popup').find('.popup-inner-close').trigger('click');

                var url = '/action/epRefund';
                url += '?eventId=' + $(confirmForm).find('input[name=eventId]').val();
                url += '&org=true';
                url += '&ajax=true';

                ajax(url, function(response){
                    if (response.indexOf('success') !== -1) {
                        t.closest('tr').find('.event-infos-td p').html(t.attr('data-info'));
                        t.addClass('disabled');
                    }
                },true); 
            });
    };

    var getEventTicketsInfos = function() {
        var btn = $(this);
        var t = btn.closest(".one-event-row");
        var eventCode = t.data('code');
        var perPage = 30;

        if (!eventCode) {
            return;
        }

        t.find('.popup').addClass('processing');
        t.find('.participants-list-table .one-participant-row:not(.clone)').remove();

        var data = {
        	validate: eventCode,
        	download: true,
        	count: perPage,
        	page: t.data('curr'),
            version: 4
        }

        if (t.find('.form-input[name=q]').length > 0 && t.find('.form-input[name=q]').val().length > 0) {
        	data.q = t.find('.form-input[name=q]').val();
        }

        $.ajax({
			url: '/action/epQR',
			cache: false,
			data: data,
			success: function (response) {
				if (response.indexOf('validityStartDate') !== -1) {
	                var data = JSON.parse(response);
	                var count = t.data('curr') > 1 ? (t.data('curr') - 1) * perPage : 0;

	                handlePager(t, data);

	                $.each(data, function(k, tickets) {
	                    if (isNaN(k.substring(0,3))) {
	                        return;
	                    }

                        $.each(tickets, function(k1, v) {
                            count++;
                            t.find(attendeesBtn).removeClass('hide');
                            
                            var ticketNumber = count;
                            var buyerName = v.buyer;
                            var ticketType = '';
                            var isFr = lang === "fr";
                            switch (v.type) {
                                case "0": 
                                    ticketType = isFr ? "Billet" : "Ticket";
                                    break;
                                case "1": 
                                    ticketType = isFr ? "Billet en palier" : "Level ticket";
                                    break;
                                case "2": 
                                    if (v.ticketType=='pass') {
                                        ticketType = isFr ? "Billet via passe" : "Ticket in pass";
                                    } else {
                                        ticketType = isFr ? "Billet via forfait" : "Ticket in package";
                                    }
                                    break;
                                case "3": 
                                    ticketType = isFr ? "Billet de consigne" : "Physical ticket";
                                    break;
                                case "4": 
                                    ticketType = isFr ? "Billet de faveur" : "Free ticket";
                                    break;
                            }
                            var ticketName = v.ticketName;
                            var ticketCode = k;
                            var ticketScannedStatus = returnScannedStatus(v.scannedIn, v.inside);
                            var buyerEmail = v.email;
                            var ticketActive = v.active;
                            var ticketScanned = v.scannedIn;
                            var buyerInside = v.inside;
                            var refunded = v.refunded;
                            var participant = (v.hasOwnProperty("participant") && v.hasOwnProperty("firstName")) ? v.participant : "";
                            var buyingMode = v.buyingMode; //0 : online ; 1 : Virtual cashier
                            if(buyerName.trim() === '' && buyingMode === '1'){
                                buyerName = isFr ? "Caisse Virtuelle" : "Virtual Cashier";
                            }
                            addNewAttendeeRow(t, ticketNumber, buyerName, ticketType, ticketName, ticketCode, ticketScannedStatus, buyerEmail, ticketActive, ticketScanned, buyerInside, refunded, participant);
                        });
                    });
	            }
                t.find('.popup').removeClass('processing');
			}
		});
    };

    var handlePager = function(t, data) {
    	var totalPages = data.page;
    	if (totalPages > 1) {
    		var currPage = t.data('curr');

			t.data('total', totalPages);

			currPage > 1 ? t.find('.pager-arrow.previous-page').fadeIn() : t.find('.pager-arrow.previous-page').fadeOut();
			currPage < totalPages ? t.find('.pager-arrow.next-page').fadeIn() : t.find('.pager-arrow.next-page').fadeOut();
			t.find('.participants-pager-total-count').html('Page ' + currPage + ' / ' + totalPages + ' - ' + 'Total: ' + data.counter + ' participants');
    	} else {
            t.find('.pager-arrow.previous-page').fadeOut();
            t.find('.pager-arrow.next-page').fadeOut();
			t.find('.participants-pager-total-count').html('Page ' + totalPages + ' - ' + 'Total: ' + data.counter + ' participants');
        }
    };

    var addNewAttendeeRow = function(t, ticketNumber, buyerName, ticketType, ticketName, ticketCode, ticketScannedStatus, buyerEmail, ticketActive, ticketScanned, buyerInside, refunded, participant) {
        var rowCopy = t.find('.table-action-btns-ctn:not(.responsive)').find('.one-participant-row.clone').clone();

        rowCopy.find('.ticket-number').html(ticketNumber);
        if(participant.trim() !== ''){
            rowCopy.find('.ticket-participant-name').html(participant);
//            t.find('.table-action-btns-ctn:not(.responsive)').find(".table-participants-list-participant-name").css("display","block");
        } else {
            rowCopy.find('.ticket-participant-name').html(buyerName);
//            rowCopy.find('.ticket-participant-name').parent("td").css("display", "none");
//            t.find('.table-action-btns-ctn:not(.responsive)').find(".table-participants-list-participant-name").css("display","none");
        }
//        rowCopy.find('.ticket-buyer-name').html(buyerName);
        rowCopy.find('.ticket-type').html(ticketType);
        rowCopy.find('.ticket-cat-name').html(ticketName);
        rowCopy.find('.ticket-code').html(ticketCode);
        rowCopy.find('.ticket-scanned-status').html(ticketScannedStatus);
        rowCopy.find('.ticket-buyer-email').html(buyerEmail);
        rowCopy.find('.table-toggle-ticket-scan-action').data('qr', ticketCode);
        rowCopy.find('.table-toggle-ticket-scan-action').data('inside', !buyerInside);
        rowCopy.find('.table-toggle-ticket-scan-action').addClass('' + !buyerInside + '').click(toggleTicketScan);
        if (ticketActive === false) {
            rowCopy.find('.table-toggle-ticket-scan-action').addClass('disabled');
        }
        rowCopy.find('.table-toggle-ticket-active-action').data('qr', ticketCode);
        rowCopy.find('.table-toggle-ticket-active-action').data('activate', !ticketActive);
        rowCopy.find('.table-toggle-ticket-active-action').addClass('' + !ticketActive + '').click(toggleTicketActive);

        if (refunded === true) {
            var refundedText = '<p>';
            if (lang = 'fr') {
                refundedText += 'Billet remboursé';
            } else {
                refundedText += 'Refunded ticket';
            }
            refundedText += '</p>';
            rowCopy.find('.table-actions-inner-ctn').remove();
            rowCopy.find('.table-action').append(refundedText);
        }

        rowCopy.removeClass('clone').removeClass('hide');
        t.find('.participants-list-table').append(rowCopy);
    };

    var toggleTicketScan = function() {
        var t = $(this);
        var eventCode = t.closest('.one-event-row').data('code');
        var qr = t.data('qr');
        var inside = t.data('inside');

        var url = '/action/epQR';
        url += '?qr=' + qr;
        url += '&validate=' + eventCode;
        url += '&scanIn=' + inside;

        ajax(url, function(response) {
            if (response.indexOf('already scanned in is out') !== -1 || response.indexOf('already scanned out is in') !== -1 || response.indexOf('valid') !== -1) {   
                t.removeClass('' + inside + '').addClass('' + !inside + '');
                t.data('inside', !inside);
                t.closest('tr').find('.ticket-scanned-status').html(returnScannedStatus(true, inside));
            }
        },true);
    };

    var toggleTicketActive = function() {
        var t = $(this);
        var eventId = t.closest('.one-event-row').data('id');
        var qr = t.data('qr');
        var activate = t.data('activate');

        var url = '/action/epQR';
        url += '?qr=' + qr;
        url += '&validate=' + eventId;
        url += '&activate=' + activate;

        ajax(url, function(response){
            if (response.indexOf('success') !== -1) {
                t.removeClass('' + activate + '').addClass('' + !activate + '');
                t.data('activate', !activate);

                if (activate === false) {
                    t.closest('td').find('.table-toggle-ticket-scan-action').addClass('disabled');
                } else {
                    t.closest('td').find('.table-toggle-ticket-scan-action').removeClass('disabled');
                }
            }
        },true);
    };

    var returnScannedStatus = function(scanned, inside) {
        var status;

        if (scanned) {
            if (lang === 'fr') { 
                status = 'Scanné ';
            } else {
                status = 'Scanned ';
            }

            if (inside) {
                status += 'in';
            } else {
                status += 'out';
            }
        } else {
            if (lang === 'fr') { 
                status = 'Non scanné';
            } else {
                status = 'Not scanned';
            }
        }

        return status;
    };

    var updateAllPopupInputs = function() {
    	// to have the same query in both popups...meh
    	var t = $(this);
    	var val = t.val();
    	var popupId = t.closest('.popup').attr('id');

    	$('.popup[id='+popupId+']').find('.search-participants-input').val(val).closest('.input-ctn').addClass('focused');
    };

    var changeParticipantsPage = function() {
    	var t = $(this);
    	var row = t.closest('.one-event-row');

    	if (t.hasClass('next-page')) {
    		row.data('curr', row.data('curr') + 1);
    	} else if (t.hasClass('previous-page')) {
    		row.data('curr', row.data('curr') - 1);
    	}

    	t.closest('.popup').find('.search-participants-btn').trigger('click');
    };

    var closePopupAndOpenAppCode = function() {
    	var t = $(this);
    	t.closest('.popup').find('.popup-inner-close').trigger('click');
    	t.closest('.table-action-btns-ctn').find('.table-app-code-action').trigger('click');
    };

    var init = function() {
        currPage = $(".page");
        meTable = $(".manage-events-table", currPage);
        deleteBtn = $(".table-delete-action", meTable);
        deleteBtn.click(deleteEvent);
        cancelBtn = $(".table-cancel-action", meTable);
        cancelBtn.click(cancelEvent);
        deleteInvitationBtn = $(".table-delete-invitation", meTable);
        deleteInvitationBtn.click(deleteInvitation);
        refundAllTicketsBtn = $(".table-refund-all-tickets-action", meTable);
        refundAllTicketsBtn.click(refundAll);
        eventRow = $('.one-event-row', meTable);
        attendeesBtn = $('.table-participants-list-action');
        attendeesBtn.on("click", getEventTicketsInfos);
        $('.search-participants-btn').on("click", getEventTicketsInfos);
        $('.search-participants-input').keyup(updateAllPopupInputs);
        $('.participants-page-btn').click(changeParticipantsPage);
        $('.app-code-instructions-btn').on("click", closePopupAndOpenAppCode);
        $('.table-app-update-action').show();
        $('.table-app-code-action').hide();
    };

    $(g).on("load", function() {
        init();
    });

    var manageEvents = Fw.component.export('manageEvents', {
        init: init,
        confirmAction:confirmAction 
    });

})(jQuery, document, window);
			